import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Award, Mail, Lock } from 'lucide-react';
import Footer from '../../components/common/Footer';
import '../../components/common/Footer.css';
import './Auth.css';

export default function LoginPage() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'שגיאה בהתחברות');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <Award size={32} />
          <h1>אישורי לימודים</h1>
        </div>
        <p className="auth-subtitle">התחברות לממשק המוסד</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">
              <Mail size={14} /> כתובת מייל
            </label>
            <input
              className="input"
              type="email"
              value={form.email}
              onChange={e => setForm({...form, email: e.target.value})}
              placeholder="mosad@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label className="label">
              <Lock size={14} /> סיסמה
            </label>
            <input
              className="input"
              type="password"
              value={form.password}
              onChange={e => setForm({...form, password: e.target.value})}
              placeholder="••••••••"
              required
            />
          </div>

          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'מתחבר...' : 'התחברות'}
          </button>
        </form>

        <p className="auth-link">
          אין לך חשבון? <Link to="/register">הרשמה</Link>
        </p>
        <Footer />
      </div>
    </div>
  );
}
